import React from "react"
import {FormControl, FormLabel, Select, Spinner} from "@chakra-ui/react";
import {LABEL} from "../../../../constants";

const ArticleDropDown = ({value, onChange, articles, loading}) => {
    return (
        <FormControl>
            {loading ? (
                <Spinner size="sm"/>
            ) : (
                <Select
                    bg="white"
                    size="sm"
                    border="1px"
                    borderColor="black"
                    borderRadius="lg"
                    value={value || ''}
                    onChange={(e) => {
                        const selectedCif = e.target.value;
                        onChange(selectedCif);
                    }}
                    placeholder={LABEL.ARTICLE_DROPDOWN.placeholder}
                >
                    {articles.map((article, index) => (
                        <option key={index} value={article.cif}>
                            {article.name}
                        </option>
                    ))}
                </Select>
            )}
        </FormControl>
    )
};

export default ArticleDropDown;